// next
// import Image from 'next/legacy/image';
// import NextLink from 'next/link';

// material-ui
import { useTheme } from "@mui/material/styles";
import { Box, Button, Container, Grid, Link, Typography } from "@mui/material";

// project import
// import Animation from "./Animation";
import MainCard from "../../components/MainCard";
// import AnimateButton from "../../components/@extended/AnimateButton";

// assets
import { SendOutlined } from "@ant-design/icons";
import imgdemo1 from "../../assets/images/landing/img-demo1.jpg";
import facematch from "../../assets/images/landing/facematch.png";
import ocr from "../../assets/images/landing/ocr.jpg";
import liveness from "../../assets/images/landing/liveness.png";

// ==============================|| LANDING - DEMO PAGE ||============================== //

const DemoBlock = () => {
  const theme = useTheme();

  return (
    <Container>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        spacing={2}
        sx={{ mt: { md: 15, xs: 2.5 }, mb: { md: 10, xs: 2.5 } }}
      >
        <Grid item xs={12}>
          <Grid
            container
            spacing={1}
            justifyContent="center"
            sx={{ mb: 4, textAlign: "center" }}
          >
            <Grid item sm={10} md={6}>
              <Grid container spacing={1} justifyContent="center">
                {/* <Grid item xs={12}>
                  <Typography variant="subtitle1" color="primary">
                    Mantis for All
                  </Typography>
                </Grid> */}
                <Grid item xs={12}>
                  <Typography variant="h2" sx={{ mb: 2 }}>
                    Serviços Isolados
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h5">
                    Seja para autenticar a identidade de um cliente, validar a
                    integridade de um documento ou garantir uma assinatura
                    eletrônica segura. o Bemsign oferece uma gama de serviços
                    integrados, otimizando cada etapa e garantindo a máxima
                    segurança.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          {/* <Animation
            variants={{
              visible: { opacity: 1 },
              hidden: { opacity: 0 },
            }}
          > */}
          <MainCard contentSX={{ p: 3 }}>
            <Grid container spacing={1.5}>
              <Grid item xs={12}>
                <Typography variant="h3" sx={{ fontWeight: 600, mt: 2 }}>
                  Liveness
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6" color="#8c8c8c">
                  Prova de vida do usuário
                </Typography>
              </Grid>
              {/* <Grid item xs={12}>
                <Box sx={{ display: "inline-block" }}>
                  <AnimateButton>
                    <Button
                      variant="outlined"
                      // endIcon={<SendOutlined />}
                      sx={{ my: 2 }}
                      component={Link}
                      href="https://www.figma.com/file/NJGFukWMHgU0LVhS4qLP4A/Mantis?node-id=106412%3A169520"
                      target="_blank"
                    >
                      Preview Figma
                    </Button>
                  </AnimateButton>
                </Box>
              </Grid> */}
              <Grid item xs={12}>
                <Box
                  sx={{
                    position: "relative",
                    width: `calc(100% + 24px)`,
                    mb: "-30px !important",
                  }}
                >
                  <img
                    src={liveness}
                    alt="feature"
                    //   layout="responsive"
                    width={370}
                  />
                </Box>
              </Grid>
            </Grid>
          </MainCard>
          {/* </Animation> */}
        </Grid>

        <Grid item xs={12} sm={4} md={4}>
          {/* <Animation
            variants={{
              visible: { opacity: 1 },
              hidden: { opacity: 0 },
            }}
          > */}
          <MainCard contentSX={{ p: 3, background: "#e6f4ff" }}>
            <Grid container spacing={1.5}>
              <Grid item xs={12}>
                <Typography variant="h3" sx={{ fontWeight: 600, mt: 2 }}>
                  Facematch
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6" color="#8c8c8c">
                  Verificação facial precisa e confiável
                </Typography>
              </Grid>
              {/* <Grid item xs={12}>
                <Box sx={{ display: "inline-block" }}>
                  <AnimateButton>
                    <Button
                      variant="outlined"
                      // endIcon={<SendOutlined />}
                      sx={{ my: 2 }}
                      component={Link}
                      href="https://www.figma.com/file/NJGFukWMHgU0LVhS4qLP4A/Mantis?node-id=106412%3A169520"
                      target="_blank"
                    >
                      Preview Figma
                    </Button>
                  </AnimateButton>
                </Box>
              </Grid> */}
              <Grid item xs={12}>
                <Box
                  sx={{
                    position: "relative",
                    width: `calc(100% + 24px)`,
                    mb: "-30px !important",
                  }}
                >
                  <img
                    src={facematch}
                    alt="feature"
                    //   layout="responsive"
                    width={370}
                  />
                </Box>
              </Grid>
            </Grid>
          </MainCard>
          {/* </Animation> */}
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          {/* <Animation
            variants={{
              visible: { opacity: 1 },
              hidden: { opacity: 0 },
            }}
          > */}
          <MainCard contentSX={{ p: 3 }}>
            <Grid container spacing={1.5}>
              <Grid item xs={12}>
                <Typography variant="h3" sx={{ fontWeight: 600, mt: 2 }}>
                  OCR e Tipificação
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6" color="#8c8c8c">
                  Reconhecimento e categorização de documentos
                </Typography>
              </Grid>
              {/* <Grid item xs={12}>
                <Box sx={{ display: "inline-block" }}>
                  <AnimateButton>
                    <Button
                      variant="outlined"
                      // endIcon={<SendOutlined />}
                      sx={{ my: 2 }}
                      component={Link}
                      href="https://www.figma.com/file/NJGFukWMHgU0LVhS4qLP4A/Mantis?node-id=106412%3A169520"
                      target="_blank"
                    >
                      Preview Figma
                    </Button>
                  </AnimateButton>
                </Box>
              </Grid> */}
              <Grid item xs={12}>
                <Box
                  sx={{
                    position: "relative",
                    width: `calc(100% + 24px)`,
                    mb: "-30px !important",
                  }}
                >
                  <img
                    src={ocr}
                    alt="feature"
                    //   layout="responsive"
                    width={370}
                  />
                </Box>
              </Grid>
            </Grid>
          </MainCard>
          {/* </Animation> */}
        </Grid>
      </Grid>
    </Container>
  );
};

export default DemoBlock;
